/**
 * Utils
 * TODO: need to verify each component show req w/ UI
 */
/**
 * Check whether the entry is the last in the array
 * @param index entry index
 * @param listLength array length
 */

export default function isLast(index: number, listLength: number) {
  return index === listLength - 1;
}
